import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { getMemberInfo } from 'shared/src/api';

export const useMarketingAlarmSettings = () => {
  return useSuspenseQuery({
    queryKey: queryKey.marketingAlarmSettings(),
    queryFn: () => getMemberInfo(),
  });
};
